import request from '@/utils/request'

export function fetchList(query) {
    return request({
        url: '/admin/payroll/list',
        method: 'get',
        params: query
    })
}

export function save(data) {
    return request({
        url: '/admin/payroll/save',
        method: 'post',
        data
    })
}

export function batchUpdate(data) {
    return request({
        url: '/admin/payroll/batchUpdate',
        method: 'post',
        data
    })
}

export function createNewMonth(data) {
    return request({
        url: '/admin/payroll/createNewMonth',
        method: 'post',
        data
    })
}

export function calcFinReport(data) {
    return request({
        url: '/admin/payroll/calcFinReport',
        method: 'post',
        data
    })
}

export function fetchLastMonth() {
    return request({
        url: '/admin/payroll/lastMonth',
        method: 'get',
    })
}

export function adjustSocialSecurity(data) {
    return request({
        url: '/admin/payroll/adjustSocialSecurity',
        method: 'post',
        data
    })
}

export function deleteMonth(data) {
    return request({
        url: '/admin/payroll/deleteMonth',
        method: 'post',
        data
    })
}

export function fetchMonthSet(query) {
    return request({
        url: '/admin/payroll/monthset',
        method: 'get',
        params: query
    })
}

export function fetchPerformanceLevel(query) {
    return request({
        url: '/admin/payroll/performanceLevel',
        method: 'get',
        params: query
    })
}
